<template>
  <v-layout>
    <v-flex>
      <lookup-select
        lookup-name="ScopesOfPractice"
        v-model="qual.scopeofpracticeid"
        :messages="
          qual.scopequalificationid > 0
            ? 'You cannot change the scope of practice on this qualification after you hit Save. Create a new Qualification, then delete this one.'
            : ''
        "
        :disabled="qual.scopequalificationid > 0"
      />

      <lookup-select lookup-name="Institutions" v-model="qual.institutionid" />

      <lookup-select lookup-name="Quals" v-model="qual.qualid" />

      <v-text-field
        type="number"
        label="Year Qualified"
        v-model="qual.qualificationdate"
      />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "QualificationForm",
  props: {
    qual: Object
  },
  created() {
    this.qual.qualificationdate = this.$moment(
      this.qual.qualificationdate
    ).format("YYYY");
  }
};
</script>
